import qs from 'qs'

import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'
import {get} from './fetch'
import SERVICES from '../config/services'

/**
 * Fetch an individual showroom's data
 *
 * @param {string} showroomSlug The individual showroom slug
 * @returns {Object}
 */
export const getShowroomLocation = (showroomSlug) =>
  get(`${SERVICES.TBT_API_URL}/v1/locations/${showroomSlug}`).then(
    onStatus({
      DEFAULT: shimJson(camelCaseObjectKeys),
    }),
  )

/**
 * Fetches all showroom locations if no zip and distance are provided. If they are,
 * returns a subset of locations within the specified range.
 *
 * @param {string|number} [zip] A valid U.S. zip code
 * @param {string|number} [distance] The bounding distance for finding locations
 * @returns {Object}
 */
export const getShowroomLocations = (zip, distance) => {
  const params = zip && distance ? qs.stringify({zip, distance}, {addQueryPrefix: true}) : ''
  return get(`${SERVICES.TBT_API_URL}/v1/locations${params}`).then(
    onStatus({
      DEFAULT: shimJson(camelCaseObjectKeys),
    }),
  )
}

/**
 * Returns a list of showroom locations ordered by distance from the user's IP address.
 *
 * @param {string|number} [distance] The bounding distance for finding locations
 * @returns {Object}
 */
export const getNearestShowroomLocations = (distance) => {
  const params = distance ? qs.stringify({distance}, {addQueryPrefix: true}) : ''
  return get(`${SERVICES.TBT_API_URL}/v1/locations/sort-by-ip${params}`).then(
    onStatus({
      DEFAULT: shimJson(camelCaseObjectKeys),
    }),
  )
}
